import StudentRouter from '@/components/pages/students/index.vue';
import Students from '@/components/pages/students/Students.vue';
import StudentDetail from '@/components/pages/students/StudentDetail.vue';
import CourseGrades from '@/components/pages/students/CourseGrades.vue'
import ImportStudent from '@/components/pages/students/ImportStudent.vue';
import ImportWetec from '@/components/pages/students/ImportWetec.vue';
import EditStudent from '@/components/pages/students/StudentEdit.vue';
import EditStudentConfirm from '@/components/pages/students/StudentEditConfirm.vue';
import PreparationLimitSetting from '@/components/pages/students/PreparationLimitSetting.vue'
import PreparationLimitModification from '@/components/pages/students/PreparationLimitModification.vue';

export default {
  path: '/students',
  name: 'StudentRouter',
  component: StudentRouter,
  children: [
    {
      path: '/students',
      component: Students,
      name: 'Students',
      meta: {
        acceptRoles: ['senior', 'partTimer', 'admin'],
      },
    },
    {
      path: '/students/importStudent',
      component: ImportStudent,
      name: 'ImportStudent',
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '/students/importWetec',
      component: ImportWetec,
      name: 'ImportStudentWetec',
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '/students/preparationLimitSetting',
      component: PreparationLimitSetting,
      name: 'PreparationLimitSetting',
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '/students/PreparationLimitSetting/modification',
      component: PreparationLimitModification,
      name: 'PreparationLimitModification',
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '/students/:studentId/courses/:courseHistoryId',
      component: CourseGrades,
      name: 'StudentCourseGrades',
      meta: {
        acceptRoles: ['senior', 'partTimer', 'admin'],
      },
    },
    {
      path: '/students/:id',
      component: StudentDetail,
      name: 'StudentDetail',
      meta: {
        acceptRoles: ['senior', 'partTimer', 'admin'],
      },
    },
    {
      path: '/students/:id/edit',
      component: EditStudent,
      name: 'EditStudent',
      meta: {
        acceptRoles: ['admin'],
      },
    },
    {
      path: '/students/:id/edit/confirm',
      component: EditStudentConfirm,
      name: 'EditStudentConfirm',
      meta: {
        acceptRoles: ['admin'],
      },
    },
  ],
}
